module.exports = __webpack_public_path__ + "static/media/icon-double-chevon-left-white.6c40cd95.svg";